/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './kyb_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbqualifier": {
        "nested": {
          "service": {
            "nested": {
              "VerificationStatus": {
                "values": {
                  "UNKNOWN_KYC_VERIFICATION_STATUS": 0,
                  "PENDING": 1,
                  "SUBMITTED": 2,
                  "PASSED": 3,
                  "FAILED": 4,
                  "IN_MANUAL_REVIEW": 5,
                  "DOCUMENTS_REQUESTED": 6
                }
              },
              "SubmitKybVerificationRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "consent": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "apiVersion": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SubmitKybVerificationResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.bbqualifier.service.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "validationErrors": {
                    "type": "squareup.bbqualifier.service.KybValidationError",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "verificationError": {
                    "type": "squareup.bbqualifier.service.KybVerificationError",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sspRequestToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "KybValidationError": {
                "fields": {
                  "errorType": {
                    "type": "squareup.bbqualifier.service.KybValidationError.ErrorType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subjectType": {
                    "type": "squareup.bbqualifier.service.KybValidationError.ErrorSubjectType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "legalEntityToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "businessLegalEntityToken": {
                    "type": "string",
                    "id": 4
                  },
                  "personaId": {
                    "type": "squareup.bbqualifier.service.KybValidationError.PersonaIdentifier",
                    "id": 5
                  }
                },
                "nested": {
                  "ErrorType": {
                    "values": {
                      "UNKNOWN_ERROR_TYPE": 0,
                      "MISSING_REQUIRED_FIELD": 1,
                      "INVALID_INPUT": 2,
                      "PO_BOX_ADDRESS": 3
                    }
                  },
                  "ErrorSubjectType": {
                    "values": {
                      "UNKNOWN_ERROR_SUBJECT_TYPE": 0,
                      "LEGAL_NAME": 1,
                      "BUSINESS_TYPE": 2,
                      "ADDRESS": 3,
                      "IDENTIFICATION_NUMBER": 4,
                      "IDENTIFICATION_NUMBER_TYPE": 5,
                      "IS_PUBLIC": 6,
                      "PERSONA_ROLE": 7,
                      "DATE_OF_BIRTH": 8,
                      "ATTESTATION": 9
                    }
                  },
                  "PersonaIdentifier": {
                    "fields": {
                      "localId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legalEntityToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "entity_identifier": {
                    "oneof": ["businessLegalEntityToken", "personaId"]
                  }
                }
              },
              "KybVerificationError": {
                "values": {
                  "UNKNOWN_KYB_VERIFICATION_ERROR": 0,
                  "NOT_RETRYABLE": 1,
                  "RETRY_LIMIT_EXCEEDED": 2,
                  "VERIFICATION_IN_PROGRESS": 3
                }
              },
              "UpdateKybRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "business": {
                    "type": "squareup.bbqualifier.service.KybBusiness",
                    "id": 2,
                    "rule": "optional"
                  },
                  "kybPersonas": {
                    "type": "squareup.bbqualifier.service.KybPersona",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "personas": {
                    "type": "squareup.bbqualifier.service.UpdateKybRequest.PersonaInfo",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "personaTokensToDelete": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "deleteAllBeneficialOwners": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "apiVersion": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PersonaInfo": {
                    "fields": {
                      "kybPersona": {
                        "type": "squareup.bbqualifier.service.KybPersona",
                        "id": 1,
                        "rule": "optional"
                      },
                      "localPersonaId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "UpdateKybResponse": {
                "fields": {
                  "kybStatus": {
                    "type": "squareup.bbqualifier.service.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "validationErrors": {
                    "type": "squareup.bbqualifier.service.KybValidationError",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "verificationError": {
                    "type": "squareup.bbqualifier.service.KybVerificationError",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "kybPersonas": {
                    "type": "squareup.bbqualifier.service.KybPersona",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "ExternalVerificationService": {
                "methods": {
                  "SubmitKybVerification": {
                    "requestType": "squareup.bbqualifier.service.SubmitKybVerificationRequest",
                    "responseType": "squareup.bbqualifier.service.SubmitKybVerificationResponse"
                  },
                  "UpdateKyb": {
                    "requestType": "squareup.bbqualifier.service.UpdateKybRequest",
                    "responseType": "squareup.bbqualifier.service.UpdateKybResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.SubmitKybVerificationRequest && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.SubmitKybVerificationResponse && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybValidationError && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybValidationError?.nested?.ErrorType && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybValidationError?.nested?.ErrorSubjectType && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybValidationError?.nested?.PersonaIdentifier && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.KybVerificationError && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.UpdateKybRequest && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.UpdateKybRequest?.nested?.PersonaInfo && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.UpdateKybResponse && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.ExternalVerificationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VerificationStatus @ squareup/bbqualifier/verification_service.proto at 48:1
 */
export const VerificationStatus = $root.lookupEnum('squareup.bbqualifier.service.VerificationStatus').values;
/**
 * SOURCE SubmitKybVerificationRequest @ squareup/bbqualifier/verification_service.proto at 104:1
 */
export const SubmitKybVerificationRequest = $root.lookupType('squareup.bbqualifier.service.SubmitKybVerificationRequest');
fixType(SubmitKybVerificationRequest, {
  unitToken: {
    notEmpty: true
  },
  consent: {
    required: true
  }
});
Builder.createAndAttachToType(SubmitKybVerificationRequest);
/**
 * SOURCE SubmitKybVerificationResponse @ squareup/bbqualifier/verification_service.proto at 112:1
 */
export const SubmitKybVerificationResponse = $root.lookupType('squareup.bbqualifier.service.SubmitKybVerificationResponse');
fixType(SubmitKybVerificationResponse);
Builder.createAndAttachToType(SubmitKybVerificationResponse);
/**
 * Form validation type of errors
 *
 * SOURCE KybValidationError @ squareup/bbqualifier/verification_service.proto at 123:1
 */
export const KybValidationError = $root.lookupType('squareup.bbqualifier.service.KybValidationError');
fixType(KybValidationError);
Builder.createAndAttachToType(KybValidationError);
/**
 * SOURCE ErrorType @ squareup/bbqualifier/verification_service.proto at 124:3
 */
KybValidationError.ErrorType = $root.lookupEnum('squareup.bbqualifier.service.KybValidationError.ErrorType').values;
/**
 * the subject of the validation error
 *
 * SOURCE ErrorSubjectType @ squareup/bbqualifier/verification_service.proto at 136:3
 */
KybValidationError.ErrorSubjectType = $root.lookupEnum('squareup.bbqualifier.service.KybValidationError.ErrorSubjectType').values;
/**
 * SOURCE PersonaIdentifier @ squareup/bbqualifier/verification_service.proto at 150:3
 */
KybValidationError.PersonaIdentifier = $root.lookupType('squareup.bbqualifier.service.KybValidationError.PersonaIdentifier');
fixType(KybValidationError.PersonaIdentifier);
Builder.createAndAttachToType(KybValidationError.PersonaIdentifier);
/**
 * Overall Kyb verification process errors
 *
 * SOURCE KybVerificationError @ squareup/bbqualifier/verification_service.proto at 171:1
 */
export const KybVerificationError = $root.lookupEnum('squareup.bbqualifier.service.KybVerificationError').values;
/**
 * SOURCE UpdateKybRequest @ squareup/bbqualifier/verification_service.proto at 179:1
 */
export const UpdateKybRequest = $root.lookupType('squareup.bbqualifier.service.UpdateKybRequest');
fixType(UpdateKybRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateKybRequest);
/**
 * SOURCE PersonaInfo @ squareup/bbqualifier/verification_service.proto at 180:3
 */
UpdateKybRequest.PersonaInfo = $root.lookupType('squareup.bbqualifier.service.UpdateKybRequest.PersonaInfo');
fixType(UpdateKybRequest.PersonaInfo, {
  localPersonaId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateKybRequest.PersonaInfo);
/**
 * SOURCE UpdateKybResponse @ squareup/bbqualifier/verification_service.proto at 205:1
 */
export const UpdateKybResponse = $root.lookupType('squareup.bbqualifier.service.UpdateKybResponse');
fixType(UpdateKybResponse);
Builder.createAndAttachToType(UpdateKybResponse);
/**
 * SOURCE ExternalVerificationService @ squareup/bbqualifier/verification_service.proto at 307:1
 */
export const ExternalVerificationService = $root.lookupService('squareup.bbqualifier.service.ExternalVerificationService');